import React, { ReactElement } from "react";
import { ToelichtingHypotheekRentevastperiodeHoofdstuk } from "../../../../../../.generated/rapportage/rapportagetypes";
import Heading from "../../../../components/Heading";
import { Column } from "../../../../components/BaseTable";
import Table from "../../../../components/Table";
import { Motivering } from "../../../../components/Motivering";
import _ from "lodash";
import { Chapter } from "../../../../components/Chapter";

type props = {
  hoofdstuk: ToelichtingHypotheekRentevastperiodeHoofdstuk;
};

const columns: Column[] = [
  {
    header: "Rentewijziging",
    accessor: "omschrijving",
    align: "left",
  },
  {
    header: "Rentedaling -0,5%",
    accessor: "bedragRentewijziging1",
    dataType: "currency",
  },
  {
    header: "Huidige rente",
    accessor: "bedragHuidigeRente",
    dataType: "currency",
  },
  {
    header: "Rentestijging +1%",
    accessor: "bedragRentewijziging2",
    dataType: "currency",
  },
  {
    header: "Rentestijging +2%",
    accessor: "bedragRentewijziging3",
    dataType: "currency",
  },
  {
    header: "Rentestijging +3%",
    accessor: "bedragRentewijziging4",
    dataType: "currency",
  },
];

const RentevastperiodeChapter = ({ hoofdstuk }: props): ReactElement => {
  const renteTable = (): ReactElement => {
    if (hoofdstuk.rentevastperiodeData) {
      return (
        <Table columns={columns} data={hoofdstuk.rentevastperiodeData}></Table>
      );
    }
    return <></>;
  };

  const wensen = [...(hoofdstuk.wens1 ?? []), ...(hoofdstuk.wens2 ?? [])];

  return (
    <Chapter>
      <div className="break-avoid">
        <Heading text={hoofdstuk.titel ?? "Rentevast periode"} level={3} />
        <Motivering
          wens={_.uniq(wensen) ?? null}
          advies={hoofdstuk.onsAdvies}
          keuze={hoofdstuk.afwijkendeKeuze}
        />
        {renteTable()}
      </div>
    </Chapter>
  );
};

export default RentevastperiodeChapter;
